// extracted by mini-css-extract-plugin
export default {"frame":"q1Dc_5Ggouao6P4etxtF","label":"bA1NEFK_gx8vKkZVGW1R","pointBox":"LSwS7ttio67cf4U8xYql","pointValue":"qr2uSOoHE9F8WBPZu3AX","pointUnit":"pveIEpO4KMAtbEnQgnnf"};